export const FREE_PLAN_ID = 0;
export const ENTERPRISE_OPENSOURCE_PLAN_ID = 9998;
export const TRIAL_PLAN_ID = 9999;
export const START_PLAN_IDS = [150, 151, 250, 251];
export const ESSENTIAL_PLAN_IDS = [152, 153, 252, 253];
export const PRO_PLAN_IDS = [154, 155, 157, 158, 254, 255, 258, 354, 355, 358];
export const ENTERPRISE_PLAN_IDS = [156, 159, 160, 256, 259, 260];

export const isFreePlan = (planId: number) => planId === FREE_PLAN_ID;
export const isTrialPlan = (planId: number) => planId === TRIAL_PLAN_ID;
export const isStartPlan = (planId: number) => START_PLAN_IDS.includes(planId);
export const isEssentialPlan = (planId: number) => ESSENTIAL_PLAN_IDS.includes(planId);
export const isProPlan = (planId: number) => PRO_PLAN_IDS.includes(planId);
// Enterprise open-source is NOT treated as real Enterprise plan anymore. It's a legacy now.
export const isEnterprisePlan = (planId: number) => ENTERPRISE_PLAN_IDS.includes(planId);
export const isPaidPlan = (planId: number) => planId > FREE_PLAN_ID && planId < ENTERPRISE_OPENSOURCE_PLAN_ID;
export const isEnterpriseOpenSourcePlan = (planId: number) => planId === ENTERPRISE_OPENSOURCE_PLAN_ID;
